<footer class="bg-dark text-white pt-4 pb-2 mt-0">
  <div class="container text-center text-md-start">
    <div class="row">
      <div class="col-md-3 mb-3">
        <h5>{{ title }}</h5>
        <p>Your trusted boat maintenance solution for awesome sailing.</p>
      </div>
      <div class="col-md-3 mb-3">
        <h5>Links</h5>
        <ul class="list-unstyled">
          <li><a class="text-white text-decoration-none" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">YachtApp Home</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/about" routerLinkActive="active">About YachtApp</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/how-it-works" routerLinkActive="active">How YachtApp Works</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/features" routerLinkActive="active">YachtApp Features</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/subscriptions" routerLinkActive="active">YachtApp Subscription Plans</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/contact" routerLinkActive="active">Contact YachtApp</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/login" routerLinkActive="active">YachtApp Login</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/register" routerLinkActive="active">YachtApp Register</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/privacy-policy" routerLinkActive="active">Privacy Policy</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/terms-and-conditions" routerLinkActive="active">Terms and Conditions</a></li>
          <li>
            <button type="button" class="btn btn-link text-white text-decoration-none p-0" (click)="openCookiePreferences()">
              Cookie Preferences
            </button>
          </li>
        </ul>
      </div>
      <nav class="col-md-3 mb-3" aria-labelledby="footer-programs-heading">
        <h5 id="footer-programs-heading">Programs</h5>
        <ul class="list-unstyled footer-programs">
          <li><a class="text-white text-decoration-none" routerLink="/crewfinder-details"><i class="bi bi-person-badge" aria-hidden="true"></i> CrewFinder Details</a></li>
          <li><a class="text-white text-decoration-none" href="https://ambassadors.yachtapp.net/"><i class="bi bi-megaphone" aria-hidden="true"></i> Ambassadors Program</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/overview"><i class="bi bi-compass" aria-hidden="true"></i> YachtApp Overview</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/yachtapp-solutions"><i class="bi bi-grid" aria-hidden="true"></i> YachtApp Solutions</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/smart-yacht-management"><i class="bi bi-gear" aria-hidden="true"></i> Smart Yacht Management</a></li>
          <li><a class="text-white text-decoration-none" routerLink="/why-yachtapp"><i class="bi bi-stars" aria-hidden="true"></i> Why YachtApp</a></li> 
        </ul>
      </nav>
      <div class="col-md-3 mb-3">
        <h5>Follow Us</h5>
        <a href="#" class="text-white me-3"><i class="bi bi-facebook"></i></a>
        <a href="#" class="text-white me-3"><i class="bi bi-twitter"></i></a>
        <a href="#" class="text-white"><i class="bi bi-instagram"></i></a>
      </div>
    </div>
    <hr class="border-light">
    <div class="text-center">
      <small>&copy; {{ currentYear }} {{ title }}. All rights reserved.</small>
    </div>
  </div>
</footer>
